const subscriptions :{[x:string]:Function[]} = {};

export function publish( topic :string,  ... args :any[]) {
  if( !subscriptions[ topic ] ) {
    return;
  }
  var e;
  for(var sub of subscriptions[topic]){
    try{
      sub.apply(null,args)
    }catch(ex){
      e = e || ex;
    }
  }
  if(e) throw e;
}
export function publishAsync( topic :string,  ... args :any[]) {
  setTimeout(()=>publish(topic, ... args),0)
}

export function subscribe( topic:string, callback:Function) {
  var topics = topic.split( /\s/ );
  if(topics.length>1){
    for(var i=0;i<topics.length;i++){
      subscribe(topics[i],callback);
    }
    return;
  }
  if(subscriptions[topic]===undefined){
    subscriptions[topic] = []
  }
  subscriptions[topic].push(callback)
}

export function unsubscribe( topic:string, callback:Function) {
  var topics = topic.split( /\s/ );
  if(topics.length>1){
    for(var i=0;i<topics.length;i++){
      unsubscribe(topics[i],callback);
    }
    return;
  }
  subscriptions[topic] = subscriptions[topic]?.filter(sub=>sub!==callback)
}